function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp1"
}, React.createElement("path", {
  d: "M0 0L260 0L260 473L0 473Z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("style", null, "\n\t\t\t\ttspan { white-space:pre }\n\t\t\t\t.shp0 { fill: #00a09b }\n\t\t\t");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page 1",
  clipPath: "url(#cp1)"
}, React.createElement("path", {
  id: "Path 1",
  className: "shp0",
  d: "M253.22 219.85L40.58 7.21C31.31 -2.05 16.24 -2.05 6.98 7.21C2.48 11.71 0 17.68 0 24.01C0 30.35 2.48 36.31 6.98 40.81L202.77 236.61L6.98 432.4C-2.29 441.66 -2.29 456.74 6.98 466C11.43 470.45 17.53 473 23.73 473C30.05 473 36.17 470.43 40.54 465.94L253.09 253.39C257.59 248.96 260.08 243.02 260.11 236.67C260.14 230.3 257.69 224.33 253.22 219.85Z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t");

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "FAQ"
}, React.createElement("g", {
  id: "ONDERWERPEN"
}, React.createElement("g", {
  id: "FAQ's"
}, React.createElement("g", {
  id: "Mijn tags"
}, React.createElement("use", {
  id: "Arrow Roght",
  href: "#img1",
  transform: "matrix(0.077,0,0,0.076,0,0)"
})))));

var SvgArrowRight2 = function SvgArrowRight2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 36",
    width: 20,
    height: 36,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("defs", null, React.createElement("svg", _extends({
    id: "img1",
    viewBox: "0 0 260 473",
    width: 260,
    height: 473,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)), _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRight2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right2.230a8128.svg";
export { ForwardRef as ReactComponent };